"use strict";
ui.loadTemplateFile("status.html");

class StatusDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _label: any;
    _message: any;

    constructor(message: any) {
        super("status.html");
        this._label = ui.label(this, ".label.status");
        this.setMessage(message);
    }

    setMessage(message: any) {
        this._message = message;
        this._update();
    }

    _update() {
        this._label.text(this._message);
    }
}

ui.StatusDialog = StatusDialog;
ui.statusDialog = function (message: any) {
    return new ui.StatusDialog(message);
};
